import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import React__default from 'react';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { useMergeRefs } from '../../hooks/useMergeRefs.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { InputRightElement, InputLeftElement } from './InputElement.js';
import { InputGroup } from './InputGroup.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
var StyledIcon = styled(Icon)(css({
  fontSize: "22px",
  transition: "color 200ms"
}));
var InputWrapper = styled(Box)(variant({
  prop: "size",
  variants: {
    sm: {
      height: "48px"
    },
    md: {
      height: "56px"
    }
  }
}), function (_a) {
  var isDisabled = _a.isDisabled,
    isFocused = _a.isFocused,
    theme = _a.theme;
  return css({
    borderRadius: "16px",
    paddingX: "16px",
    display: "block",
    cursor: isDisabled ? "auto" : "text",
    width: "100%",
    transition: "all 200ms ease-in-out",
    boxShadow: "inset 0 0 0 0 rgba(255,255,255,0), inset 0 0 0 ".concat(isFocused ? "2px" : "1px", " ").concat(theme.colors.grey[5], ", inset 0 0 0 9999px ").concat(theme.colors.base),
    ":hover": {
      boxShadow: "inset 0 0 0 0 rgba(255,255,255,0), inset 0 0 0 ".concat(isFocused ? "2px" : "1px", " ").concat(theme.colors.grey[5], ", inset 0 0 0 9999px ").concat(isFocused ? theme.colors.base : theme.colors.grey[8])
    }
  });
});
var StyledInput = styled.input(css({
  border: "0",
  appearance: "none",
  outline: "none",
  fontSize: "16px",
  fontFamily: "matter",
  color: "textPrimary",
  width: "100%",
  backgroundColor: "unset",
  paddingX: "36px",
  paddingTop: "1px",
  paddingBottom: "0",
  lineHeight: "20px",
  "::placeholder": {
    color: "grey.1",
    lineHeight: "20px",
    transition: "opacity 300ms ease-in-out"
  },
  ":focus::placeholder": {
    opacity: 0
  }
}));
var StyledInputRightElement = styled(InputRightElement)(css({
  cursor: "pointer",
  color: "grey.1",
  transition: "all 200ms ease-in-out",
  ":hover": {
    color: "textPrimary"
  }
}));
var SearchInput = React__default.forwardRef(function (_a, ref) {
  var onChange = _a.onChange;
  _a.isInvalid;
  var onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    _b = _a.size,
    size = _b === void 0 ? "md" : _b,
    _c = _a.isClearable,
    isClearable = _c === void 0 ? true : _c,
    rest = __rest(_a, ["onChange", "isInvalid", "onFocus", "onBlur", "size", "isClearable"]);
  var defaultValue = rest.defaultValue,
    valueProp = rest.value,
    backgroundColor = rest.backgroundColor,
    disabled = rest.disabled;
  var _d = React__default.useState(false),
    isFocused = _d[0],
    setIsFocused = _d[1];
  var _e = React__default.useState(""),
    value = _e[0],
    setValue = _e[1];
  var inputRef = React__default.useRef(null);
  var mergedRef = useMergeRefs(inputRef, ref);
  var hasValue = value.length > 0;
  React__default.useEffect(function () {
    setValue(String(defaultValue || valueProp || ""));
  }, [defaultValue, valueProp]);
  var handleClick = React__default.useCallback(function () {
    var _a;
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  }, []);
  var handleFocus = React__default.useCallback(function (e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  }, [onFocus]);
  var handleBlur = React__default.useCallback(function (e) {
    var _a;
    setIsFocused(false);
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }, [onBlur]);
  var handleChange = React__default.useCallback(function (e) {
    setValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [onChange]);
  var handleClear = React__default.useCallback(function () {
    var _a, _b;
    var nativeInputValueSetter = (_a = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) === null || _a === void 0 ? void 0 : _a.set;
    nativeInputValueSetter === null || nativeInputValueSetter === void 0 ? void 0 : nativeInputValueSetter.call(inputRef.current, "");
    var event = new Event("input", {
      bubbles: true
    });
    (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.dispatchEvent(event);
  }, []);
  return React__default.createElement(InputGroup, null, React__default.createElement(InputLeftElement, null, React__default.createElement(StyledIcon, {
    icon: "search",
    color: isFocused ? "textPrimary" : "grey.2"
  })), React__default.createElement(InputWrapper, {
    as: "label",
    onClick: handleClick,
    backgroundColor: backgroundColor || "grey.4",
    borderColor: "grey.5",
    isDisabled: disabled,
    isFocused: isFocused,
    size: size
  }, React__default.createElement(Box, {
    height: "calc(100% - 1px)",
    width: "100%",
    display: "flex",
    alignItems: "center"
  }, React__default.createElement(StyledInput, __assign({}, rest, {
    onFocus: handleFocus,
    ref: mergedRef,
    onBlur: handleBlur,
    onChange: handleChange,
    value: value
  })))), hasValue && isClearable && React__default.createElement(StyledInputRightElement, {
    onClick: handleClear
  }, React__default.createElement(Icon, {
    icon: "cancel_fill",
    fontSize: "20px",
    color: "inherit"
  })));
});
export { SearchInput };